'use strict';

module.exports = {
  __depends__: [ require(242) ],
  __init__: [ 'handTool' ],
  handTool: [ 'type', require(167) ]
};
